module.exports = __webpack_public_path__ + "img/材料力学6_3.e89e2c6a.jpg";